"use client";

import { useReportWebVitals } from "next/web-vitals";
import { isPublicAnalyticsPath, pageViewEventFor } from "@/lib/analytics/page-view";
import { trackEvent } from "@/lib/analytics/track";

type ReportWebVitalsCallback = Parameters<typeof useReportWebVitals>[0];

const reportWebVitals: ReportWebVitalsCallback = (metric) => {
  const pathname = typeof window !== "undefined" ? window.location.pathname : "";
  if (!isPublicAnalyticsPath(pathname)) return;
  const pageView = pageViewEventFor(pathname);
  if (!pageView) return;

  trackEvent("web_vital", {
    page_type: pageView.props.page_type,
    metric_id: metric.id,
    metric_name: metric.name,
    metric_value: Number(metric.value.toFixed(3)),
    metric_delta: Number(metric.delta.toFixed(3)),
    metric_rating: metric.rating,
    navigation_type: metric.navigationType,
  });
};

export default function WebVitalsReporter() {
  useReportWebVitals(reportWebVitals);
  return null;
}
